/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'well-signup-card-layout',
  templateUrl: './signup-card-layout.component.html',
  styleUrls: ['./signup-card-layout.component.scss'],
})
export class SignupCardLayoutComponent implements OnInit {

  @Input() height = 'fit-content';

  @Input() title = '';

  @Input() icon = false;

  constructor() {
  }

  ngOnInit(): void {
  }
}
